import { EvScreenshotService } from '@evinced-private/ui-common';

export const ScreenshotService = new EvScreenshotService();
